import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SubmissionDraftContext } from "../context/SubmissionDraftContext";
import CustomDropdown from "../components/CustomDropdown";
import { JOURNAL_OPTIONS } from "../data/submissionData";

export default function JournalDetails() {
  const CUSTOM_JOURNAL_VALUE = "__custom__";
  const navigate = useNavigate();
  const { draft, updateDraft } = useContext(SubmissionDraftContext);
  const [error, setError] = useState("");

  const clearPage = () => {
    updateDraft({
      msId: "",
      msTitle: "",
      journalName: "",
      journalNameManual: ""
    });
    setError("");
  };

  const journalOptions = useMemo(
    () => [
      ...JOURNAL_OPTIONS.map((item) => ({ value: item, label: item })),
      { value: CUSTOM_JOURNAL_VALUE, label: "Custom (Enter manually)" }
    ],
    []
  );

  const goNext = () => {
    const resolvedJournalName = (
      draft.journalName === CUSTOM_JOURNAL_VALUE
        ? draft.journalNameManual
        : draft.journalName
    || "").trim();
    if (!draft.msId.trim() || !draft.msTitle.trim() || !resolvedJournalName) {
      setError("Manuscript ID, title and journal name are required.");
      return;
    }
    if (draft.msId.trim().length < 3) {
      setError("Manuscript ID must be at least 3 characters.");
      return;
    }
    if (draft.msTitle.trim().length < 5) {
      setError("Manuscript title must be at least 5 characters.");
      return;
    }
    if (draft.journalName === CUSTOM_JOURNAL_VALUE && draft.journalNameManual?.trim()) {
      updateDraft({ journalName: draft.journalNameManual.trim() });
    }
    setError("");
    navigate("/terms-and-conditions");
  };

  return (
    <div className="workspace-card section-card">
      <div className="section-header-row">
        <h2>Journal Details</h2>
        <button className="toolbar-btn compact-btn" onClick={clearPage}>
          Clear
        </button>
      </div>

      <div className="details-form-grid">
        <label>Manuscript ID</label>
        <div>
          <input
            className="toolbar-input"
            value={draft.msId}
            onChange={(event) => updateDraft({ msId: event.target.value })}
          />
        </div>

        <label>Manuscript Title</label>
        <div>
          <textarea
            className="toolbar-input"
            value={draft.msTitle}
            onChange={(event) => updateDraft({ msTitle: event.target.value })}
            rows={3}
          />
        </div>

        <label>Journal Name</label>
        <div>
          <CustomDropdown
            className="toolbar-select"
            searchable
            options={journalOptions}
            value={draft.journalName || ""}
            onChange={(nextValue) =>
              updateDraft({
                journalName: nextValue,
                journalNameManual: nextValue === CUSTOM_JOURNAL_VALUE ? draft.journalNameManual : ""
              })
            }
            placeholder="Select Journal Name"
          />
          {draft.journalName === CUSTOM_JOURNAL_VALUE && (
            <input
              className="toolbar-input"
              placeholder="Enter custom journal name"
              value={draft.journalNameManual || ""}
              onChange={(event) =>
                updateDraft({
                  journalNameManual: event.target.value
                })
              }
            />
          )}
        </div>
      </div>

      {error && <p className="submit-error">{error}</p>}

      <div className="wizard-actions">
        <button className="toolbar-btn" onClick={() => navigate("/author-details")}>
          Previous
        </button>
        <button className="toolbar-btn primary-btn" onClick={goNext}>
          Next
        </button>
      </div>
    </div>
  );
}
